import React from "react";
import Svg, { Path, Defs, LinearGradient, Stop } from "react-native-svg";

export default function ReturnIcon() {
  return (
    <Svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.8188 17.017C25.0426 11.2419 21.5255 7.0481 16.485 6.56509C12.5448 6.18751 8.38315 8.16265 4.75057 12.2766C4.75196 12.0787 4.75371 11.884 4.75573 11.6942C4.76354 10.9603 4.77527 10.3103 4.78504 9.84396C4.78992 9.61093 4.79431 9.42408 4.79746 9.29593L4.80117 9.14937L4.80216 9.11209L4.80241 9.10297L4.80247 9.10085L4.80248 9.10041L4.80248 9.10038L4.80248 9.10034C4.83523 7.91501 3.90088 6.92756 2.71554 6.89479C1.53019 6.86202 0.542713 7.79638 0.509948 8.98173L2.65621 9.04106C0.509948 8.98173 0.509946 8.98179 0.509944 8.98187L0.509937 8.98212L0.509914 8.98294L0.509836 8.98581L0.509547 8.99646L0.508474 9.0369L0.504588 9.19024C0.501318 9.3231 0.496808 9.51522 0.491805 9.75401C0.481804 10.2314 0.469804 10.8965 0.461799 11.6485C0.445929 13.1393 0.445137 15.0186 0.511428 16.4497L0.512016 16.4624L0.512754 16.475C0.540556 16.9528 0.6624 17.4203 0.871298 17.8509C1.0802 18.2815 1.37204 18.6665 1.73008 18.984C2.08813 19.3016 2.50534 19.5453 2.95778 19.7012C3.39758 19.8527 3.86225 19.9185 4.32658 19.8949L11.4762 19.6724C12.6615 19.6355 13.5924 18.6448 13.5555 17.4596C13.5186 16.2743 12.5279 15.3434 11.3427 15.3803L7.63976 15.4955C10.7615 11.774 13.8652 10.6279 16.0754 10.8397C18.5693 11.0787 20.9695 13.1744 21.5629 17.589C21.7209 18.7643 22.8016 19.5889 23.9769 19.431C25.1521 19.273 25.9768 18.1923 25.8188 17.017Z"
        fill="url(#paint0_linear_return)"
      />
      <Defs>
        <LinearGradient
          id="paint0_linear_return"
          x1="0.45288"
          y1="9.42122"
          x2="4.39827"
          y2="24.7162"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#05858A" />
          <Stop offset="1" stopColor="#2AE8CB" />
        </LinearGradient>
      </Defs>
    </Svg>
  );
}
